var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-outline",style:(_vm.cssProps),on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }